import { serviceManager } from ".";
import ObjectsOperations from "@utils/objects/operations";

export const logger = {
    debug: (namespace: string, message: string | object, object?: any) => {
        serviceManager.sendMessageToWorker({
            serviceName: "LOG_SYNC",
            serviceData: {
                origin: "MAIN_THREAD",
                command: "LOG_GENERAL",
                payload: { logLevel: "DEBUG", namespace, message, object: object ? ObjectsOperations.typeSafeStructuredClone(object) : undefined },
            }
        });

    },
    info: (namespace: string, message: string | object, object?: any) => {
        serviceManager.sendMessageToWorker({
            serviceName: "LOG_SYNC",
            serviceData: {
                origin: "MAIN_THREAD",
                command: "LOG_GENERAL",
                payload: { logLevel: "INFO", namespace, message, object: object ? ObjectsOperations.typeSafeStructuredClone(object) : undefined },
            }
        });
    },
    warn: (namespace: string, message: string | object, object?: any) => {
        serviceManager.sendMessageToWorker({
            serviceName: "LOG_SYNC",
            serviceData: {
                origin: "MAIN_THREAD",
                command: "LOG_GENERAL",
                payload: { logLevel: "WARN", namespace, message, object: object ? ObjectsOperations.typeSafeStructuredClone(object) : undefined },
            }
        });
    },
    error: (namespace: string, message: string | object, object?: any) => {
        serviceManager.sendMessageToWorker({
            serviceName: "LOG_SYNC",
            serviceData: {
                origin: "MAIN_THREAD",
                command: "LOG_GENERAL",
                payload: { logLevel: "ERROR", namespace, message, object: object ? ObjectsOperations.deepCopyNestedObjectExpensive(object) : undefined },
            }
        });
    }
};

export const apiLogger = {
    debug: (caller: string, endPoint: string, status: number, requestTime: number, response?: any) => {
        serviceManager.sendMessageToWorker({
            serviceName: "LOG_SYNC",
            serviceData: {
                origin: "MAIN_THREAD",
                command: "LOG_API",
                payload: { logLevel: "DEBUG", caller, endPoint, status, requestTime, response: response ? ObjectsOperations.typeSafeStructuredClone(response) : undefined },
            }
        });
    },
    info: (caller: string, endPoint: string, status: number, requestTime: number, response?: any) => {
        serviceManager.sendMessageToWorker({
            serviceName: "LOG_SYNC",
            serviceData: {
                origin: "MAIN_THREAD",
                command: "LOG_API",
                payload: { logLevel: "INFO", caller, endPoint, status, requestTime, response: response ? ObjectsOperations.typeSafeStructuredClone(response) : undefined },
            }
        });
    },
    warn: (caller: string, endPoint: string, status: number, requestTime: number, response?: any) => {
        serviceManager.sendMessageToWorker({
            serviceName: "LOG_SYNC",
            serviceData: {
                origin: "MAIN_THREAD",
                command: "LOG_API",
                payload: { logLevel: "WARN", caller, endPoint, status, requestTime, response: response ? ObjectsOperations.typeSafeStructuredClone(response) : undefined },
            }
        });
    },
    error: (caller: string, endPoint: string, status: number, requestTime: number, response?: any) => {
        serviceManager.sendMessageToWorker({
            serviceName: "LOG_SYNC",
            serviceData: {
                origin: "MAIN_THREAD",
                command: "LOG_API",
                payload: { logLevel: "ERROR", caller, endPoint, status, requestTime, response: response ? ObjectsOperations.deepCopyNestedObjectExpensive(response) : undefined },
            }
        });
    }
};